import { render, staticRenderFns } from "./ExistingTournamentMatchForms.vue?vue&type=template&id=04226cd8&scoped=true"
import script from "./ExistingTournamentMatchForms.vue?vue&type=script&lang=js"
export * from "./ExistingTournamentMatchForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04226cd8",
  null
  
)

export default component.exports